import axios from 'axios';

export default function offerDetails(token, id, offer, promo) {
    return axios.get('/api/changeoffer/estimate', {
        params: {
            vpsId: id,
            newOfferId: offer,
            promoCode: promo
        },
        headers: { Authorization: token }
    });
}
